/**
 * Created by hernanherreros on 2019-05-03
 */

import { Request } from 'fetchboi'

export const getRequestToken = Request.register({
  endpoint: '/accessTokens/:token',
  method: 'get',
  useAuthentication: true,
})

export const confirmRequest = Request.register({
  endpoint: '/accessTokens/:token/confirm',
  method: 'put',
  useAuthentication: true,
})
